<script>
  export let name;
  import SideBar from "./components/Sidebar/SideBar.svelte";
  import Content from "./components/Page/Content.svelte";
  import Heading from "./components/Header/Header.svelte";
</script>

<style>
  div {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 5em 1fr;
    grid-template-areas:
      "header header"
      "contents contents";
    width: 100vw;
	height: 100vh;
	overflow: auto;
  }

  .sidebar {
    grid-area: sidebar;
    width: 100%;
    height: 100%;
  }

  .contents {
    grid-area: contents;
    width: 100%;
    height: 100%;
  }

  .header {
	grid-area: header;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: white;
  }

  video {
    position: fixed;
    top: -30%;
    left: -5%;
    width: auto;
    height: auto;
    min-height: 140%;
    min-width: 110%;
    z-index: -100;
    filter: blur(20px) brightness(110%) contrast(80%) saturate(80%) sepia(10%);
  }

  @media screen and (max-width: 1100px) {
    video {
      left: -70%;
    }
  }
  @media screen and (max-width: 600px) {
    video {
      left: -120%;
    }
  }
</style>

<div>

  <video autoplay muted loop playsinline id="myVideo">
    <source src="videos/scratch.mov" type="video/mp4" />
  </video>

  <span class="header">
    <Heading />
  </span>

  <!-- <span class="sidebar">
	<SideBar />
	</span> -->

  <span class="contents">
    <Content />
  </span>

</div>
